import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import dayjs from "dayjs";
import DateRangeSelector from "../daterangepicker/DateRangeSelector";
import {  faChevronRight, faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const SvDashboardFilters = ({ currentfilter, currentDate, updateWeek, counts, setCurrentFilter, applyfilter }) => {
  const [openCalendar, setOpenCalendar] = useState(false);
  const calendarRef = useRef(null); 
  const navigate=useNavigate()
    const handleDateRangeSubmit = () => {
    // Ensure that the current date range is updated properly
    setOpenCalendar(false); // Close the calendar after selection
  };

  const filters = [
    { label: "All" },
    { label: "Pending" },
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setOpenCalendar(false);
      }
    };

    // Add event listener for click
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="flex flex-wrap items-center justify-between p-4 gap-4">
      {/* Left Side: Arrow Icon and Filter Buttons */}
      <div className="flex flex-wrap items-center gap-4">
        {/* <div className="p-2 bg-[#F3F4F6] rounded-md bg-opacity-80">
          <FontAwesomeIcon icon={faArrowLeft} className="text-xl cursor-pointer text-black" />
        </div> */}

        {/* Filter Buttons */}
        <div className="flex flex-wrap gap-2 font-inter">
          {filters.map((filter) => (
            <button
              key={filter.label}
              onClick={() => {
                setCurrentFilter(filter.label);
                applyfilter(filter.label);
              }}
              className={`min-w-[80px] px-4 py-2 font-inter text-[14px] rounded-md transition-colors duration-200 ${
                currentfilter === filter.label ? "bg-[#900] text-white" : "bg-gray-300 text-black bg-opacity-80"
              }`}
            >
              {filter.label} ({counts[filter.label]})
            </button>
          ))}
        </div>
      </div>
      <div className="flex gap-4">
      <button
          onClick={()=>navigate('/recap')}
            className="min-w-[50px] px-4  rounded-md transition-colors duration-200 bg-[#900] text-white"
          >
            Recap
          </button>
      {/* Right Side: Week Navigation */}
             <div className="flex items-center gap-4">
                  <button onClick={() => updateWeek("prev")} className="p-2 rounded-md">
                    <FontAwesomeIcon icon={faChevronLeft} className="text-[#293050] text-sm" />
                  </button>
      
                  <span className="text-[#293050] font-medium">
                    {/* {currentDate.startDate.format("DD MMM, YYYY")} - {currentDate.endDate.format("DD MMM, YYYY")} */}
             {dayjs(currentDate.startDate).isValid() ? dayjs(currentDate.startDate).format("DD MMM, YYYY") : "--"} - 
{dayjs(currentDate.endDate).isValid() ? dayjs(currentDate.endDate).format("DD MMM, YYYY") : "--"}



                  </span>
      
                  <button onClick={() => updateWeek("next")} className="p-2 rounded-md">
                    <FontAwesomeIcon icon={faChevronRight} className="text-[#293050] text-sm" />
                  </button>
                </div>
      </div>
     
      {/* <div
        className="flex relative items-center gap-4 border border-red-300 py-1 cursor-pointer px-4 rounded"
        onClick={() => setOpenCalendar(true)} // Open the calendar on click
      >
        <span className="text-[#293050] font-medium font-inter mt-1">
          {dayjs(selectedDateRange.startDate).format("DD-MMM, YYYY")} - {dayjs(selectedDateRange.endDate).format("DD-MMM, YYYY")}
        </span>
      </div> */}

      {/* Conditional rendering of DateRangeSelector */}
      {/* {openCalendar && (
        <div ref={calendarRef}  className="absolute top-[20%] right-10 z-10">
          <DateRangeSelector
            selectedDateRange={selectedDateRange}
            setSelectedDateRange={setSelectedDateRange}
            onSubmit={handleDateRangeSubmit}
          />
        </div>
      )} */}
    </div>
  );
};

export default SvDashboardFilters;
